import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "v-card-header d-flex align-items-center justify-content-between" }
const _hoisted_2 = { class: "trezo-table-content" }
const _hoisted_3 = { class: "trezo-table" }
const _hoisted_4 = { class: "customer-info d-flex align-items-center" }
const _hoisted_5 = { class: "img" }
const _hoisted_6 = { class: "d-block text-black fw-medium" }
const _hoisted_7 = { class: "action-buttons d-flex align-items-center" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "material-symbols-outlined" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "material-symbols-outlined" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "material-symbols-outlined" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 0,
  class: "p-4 text-center text-body"
}
const _hoisted_16 = {
  key: 1,
  class: "p-4 text-center",
  style: {"color":"#c0392b"}
}
const _hoisted_17 = {
  key: 0,
  class: "d-flex align-items-center justify-content-between px-4 py-3 border-top"
}
const _hoisted_18 = {
  class: "text-body",
  style: {"font-size":"13px"}
}
const _hoisted_19 = { class: "d-flex gap-2" }
const _hoisted_20 = { class: "ud-header" }
const _hoisted_21 = { class: "ud-left" }
const _hoisted_22 = { class: "ud-meta" }
const _hoisted_23 = { class: "ud-name" }
const _hoisted_24 = { class: "ud-sub" }
const _hoisted_25 = { class: "ud-edit-grid" }
const _hoisted_26 = { class: "ud-sub mt-1" }
const _hoisted_27 = { class: "ud-actions" }
const _hoisted_28 = {
  key: 0,
  class: "p-4",
  style: {"color":"#c0392b"}
}
const _hoisted_29 = {
  key: 1,
  class: "p-4"
}
const _hoisted_30 = {
  key: 2,
  class: "p-4"
}
const _hoisted_31 = { class: "d-flex align-center justify-space-between" }
const _hoisted_32 = { class: "row g-3" }
const _hoisted_33 = { class: "col-12 col-lg-12" }
const _hoisted_34 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_35 = {
  class: "text-body",
  style: {"font-size":"12px"}
}
const _hoisted_36 = { class: "mt-3" }
const _hoisted_37 = {
  class: "d-flex justify-content-between text-body",
  style: {"font-size":"13px"}
}
const _hoisted_38 = {
  class: "mt-3 d-flex flex-wrap",
  style: {"gap":"10px"}
}
const _hoisted_39 = {
  class: "badge bg-light text-dark",
  style: {"border":"1px solid #eceef2"}
}
const _hoisted_40 = {
  class: "badge bg-light text-dark",
  style: {"border":"1px solid #eceef2"}
}
const _hoisted_41 = {
  class: "badge bg-light text-dark",
  style: {"border":"1px solid #eceef2"}
}
const _hoisted_42 = {
  class: "badge bg-light text-dark",
  style: {"border":"1px solid #eceef2"}
}
const _hoisted_43 = {
  key: 0,
  class: "mt-3",
  style: {"border-top":"1px dashed #eceef2","padding-top":"14px"}
}
const _hoisted_44 = { class: "row g-2" }
const _hoisted_45 = { class: "col-12 col-md-4" }
const _hoisted_46 = { class: "col-12 col-md-4" }
const _hoisted_47 = { class: "col-12 col-md-4" }
const _hoisted_48 = { class: "col-12 col-md-4" }
const _hoisted_49 = {
  class: "text-body mt-2",
  style: {"font-size":"12px"}
}
const _hoisted_50 = { class: "d-flex align-items-center justify-content-between mb-2" }
const _hoisted_51 = {
  class: "text-body",
  style: {"font-size":"12px"}
}
const _hoisted_52 = { class: "d-flex justify-content-between align-items-center mb-2" }
const _hoisted_53 = {
  class: "text-body",
  style: {"font-size":"12px"}
}
const _hoisted_54 = {
  class: "d-flex align-items-center",
  style: {"gap":"8px","flex-wrap":"wrap"}
}
const _hoisted_55 = {
  class: "badge bg-light text-dark",
  style: {"border":"1px solid #eceef2"}
}
const _hoisted_56 = {
  key: 0,
  class: "badge bg-light text-dark",
  style: {"border":"1px solid #eceef2"}
}
const _hoisted_57 = {
  class: "text-body mb-3",
  style: {"white-space":"pre-wrap"}
}
const _hoisted_58 = ["innerHTML"]
const _hoisted_59 = {
  key: 1,
  class: "text-body"
}
const _hoisted_60 = {
  key: 2,
  class: "mt-3"
}
const _hoisted_61 = { class: "attachments" }
const _hoisted_62 = {
  key: 0,
  class: "p-3 text-center text-body"
}
const _hoisted_63 = {
  class: "px-4 py-3 d-flex justify-content-end",
  style: {"border-top":"1px solid #eceef2"}
}
const _hoisted_64 = {
  class: "d-flex align-items-center justify-content-between px-4 py-3",
  style: {"border-bottom":"1px solid #eceef2"}
}
const _hoisted_65 = {
  key: 0,
  class: "mb-3 p-3 bg-light",
  style: {"color":"#c0392b","border-radius":"8px"}
}
const _hoisted_66 = {
  class: "px-4 py-3 d-flex justify-content-end",
  style: {"border-top":"1px solid #eceef2","gap":"10px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "users-list-card trezo-card border-radius d-block bg-white border-0 shadow-none" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("form", {
          class: "search-box position-relative",
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
        }, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "input-search d-block",
            placeholder: "Kullanıcı ara...",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
            onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSearchInput && _ctx.onSearchInput(...args)))
          }, null, 544), [
            [_vModelText, _ctx.searchTerm]
          ]),
          _cache[27] || (_cache[27] = _createElementVNode("button", { type: "submit" }, [
            _createElementVNode("i", { class: "material-symbols-outlined" }, "search")
          ], -1))
        ], 32),
        _createVNode(_component_v_btn, {
          color: "primary",
          onClick: _ctx.openCreateDialog
        }, {
          default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
            _createElementVNode("i", { class: "material-symbols-outlined me-1" }, "person_add", -1),
            _createTextVNode(" Yeni Kullanıcı Ekle ", -1)
          ]))]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_v_table, null, {
            default: _withCtx(() => [
              _cache[30] || (_cache[30] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { class: "text-start" }, "Kullanıcı ID"),
                  _createElementVNode("th", { class: "text-start" }, "Kullanıcı"),
                  _createElementVNode("th", { class: "text-start" }, "Kullanıcı Adı"),
                  _createElementVNode("th", { class: "text-start" }, "E-posta"),
                  _createElementVNode("th", { class: "text-start" }, "Rol"),
                  _createElementVNode("th", { class: "text-start" }, "Kayıt Tarihi"),
                  _createElementVNode("th", { class: "text-start" }, "İşlem")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredItems, (item) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: item.id
                  }, [
                    _createElementVNode("td", null, _toDisplayString(item.userID), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                          _createVNode(_component_v_img, {
                            class: "rounded-circle",
                            src: item.user.image,
                            alt: "user-image"
                          }, null, 8, ["src"])
                        ]),
                        _createElementVNode("span", _hoisted_6, _toDisplayString(item.user.name), 1)
                      ])
                    ]),
                    _createElementVNode("td", null, _toDisplayString(item.username), 1),
                    _createElementVNode("td", null, _toDisplayString(item.email), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["badge", item.role === 'admin' ? 'bg-danger' : 'bg-secondary']),
                        style: {"font-size":"11px"}
                      }, _toDisplayString(item.role === 'admin' ? 'Admin' : 'Kullanıcı'), 3)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(item.joinDate), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("button", {
                          type: "button",
                          title: "Görüntüle",
                          onClick: ($event: any) => (_ctx.openUserDetails(item, false))
                        }, [
                          _createElementVNode("i", _hoisted_9, _toDisplayString(item.action.view), 1)
                        ], 8, _hoisted_8),
                        _createElementVNode("button", {
                          type: "button",
                          title: "Düzenle",
                          onClick: ($event: any) => (_ctx.openUserDetails(item, true))
                        }, [
                          _createElementVNode("i", _hoisted_11, _toDisplayString(item.action.edit), 1)
                        ], 8, _hoisted_10),
                        _createElementVNode("button", {
                          type: "button",
                          title: "Sil",
                          onClick: ($event: any) => (_ctx.deleteUser(item))
                        }, [
                          _createElementVNode("i", _hoisted_13, _toDisplayString(item.action.delete), 1)
                        ], 8, _hoisted_12)
                      ])
                    ])
                  ]))
                }), 128)),
                (!_ctx.loading && _ctx.filteredItems.length === 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [...(_cache[29] || (_cache[29] = [
                      _createElementVNode("td", {
                        colspan: "7",
                        class: "text-center text-body"
                      }, "Kayıt bulunamadı.", -1)
                    ]))]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }),
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, "Yükleniyor…"))
            : _createCommentVNode("", true),
          (_ctx.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.error), 1))
            : _createCommentVNode("", true)
        ]),
        (_ctx.totalPages > 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createElementVNode("span", _hoisted_18, " Toplam " + _toDisplayString(_ctx.totalUsers) + " kullanıcı — Sayfa " + _toDisplayString(_ctx.currentPage) + " / " + _toDisplayString(_ctx.totalPages), 1),
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_v_btn, {
                  size: "small",
                  variant: "outlined",
                  disabled: _ctx.currentPage <= 1,
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goToPage(_ctx.currentPage - 1)))
                }, {
                  default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                    _createTextVNode("Önceki", -1)
                  ]))]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_v_btn, {
                  size: "small",
                  variant: "outlined",
                  disabled: _ctx.currentPage >= _ctx.totalPages,
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goToPage(_ctx.currentPage + 1)))
                }, {
                  default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                    _createTextVNode("Sonraki", -1)
                  ]))]),
                  _: 1
                }, 8, ["disabled"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_v_dialog, {
        modelValue: _ctx.detailsDialog,
        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.detailsDialog) = $event)),
        "max-width": "1100",
        scrollable: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, { class: "border-radius" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  (_ctx.selectedUser?.user?.image)
                    ? (_openBlock(), _createBlock(_component_v_img, {
                        key: 0,
                        src: _ctx.selectedUser.user.image,
                        width: "44",
                        height: "44",
                        class: "rounded-circle ud-avatar"
                      }, null, 8, ["src"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_22, [
                    (!_ctx.editMode)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.selectedUser?.user?.name || "Kullanıcı"), 1),
                          _createElementVNode("div", _hoisted_24, [
                            _createTextVNode(_toDisplayString(_ctx.selectedUser?.email || "—") + " ", 1),
                            _cache[33] || (_cache[33] = _createElementVNode("span", { class: "ud-dot" }, "•", -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.selectedUser?.userID || ""), 1)
                          ])
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("div", _hoisted_25, [
                            _createVNode(_component_v_text_field, {
                              modelValue: _ctx.editForm.user.name,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.editForm.user.name) = $event)),
                              label: "Ad Soyad",
                              density: "compact",
                              variant: "outlined",
                              "hide-details": ""
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_v_text_field, {
                              modelValue: _ctx.editForm.user.username,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.editForm.user.username) = $event)),
                              label: "Kullanıcı Adı",
                              density: "compact",
                              variant: "outlined",
                              "hide-details": ""
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_v_text_field, {
                              modelValue: _ctx.editForm.user.email,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.editForm.user.email) = $event)),
                              label: "E-posta",
                              density: "compact",
                              variant: "outlined",
                              "hide-details": "",
                              style: {"grid-column":"1 / -1"}
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_v_text_field, {
                              modelValue: _ctx.editForm.user.password,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.editForm.user.password) = $event)),
                              label: "Yeni Şifre (boş bırakılırsa değişmez)",
                              type: "password",
                              density: "compact",
                              variant: "outlined",
                              "hide-details": "",
                              class: "mt-2",
                              style: {"grid-column":"1 / -1"}
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_v_select, {
                              modelValue: _ctx.editForm.role,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.editForm.role) = $event)),
                              items: [{ title: 'Kullanıcı', value: 'user' }, { title: 'Admin', value: 'admin' }],
                              label: "Rol",
                              density: "compact",
                              variant: "outlined",
                              "hide-details": "",
                              class: "mt-2",
                              style: {"grid-column":"1 / -1"}
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.selectedUser?.userID || ""), 1)
                        ], 64))
                  ])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createVNode(_component_v_btn, {
                    variant: "outlined",
                    density: "comfortable",
                    loading: _ctx.detailsLoading,
                    disabled: _ctx.saveLoading,
                    onClick: _ctx.reloadUserDetails
                  }, {
                    default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                      _createTextVNode(" Yenile ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["loading", "disabled", "onClick"]),
                  _createVNode(_component_v_btn, {
                    variant: "outlined",
                    density: "comfortable",
                    loading: _ctx.saveLoading,
                    disabled: _ctx.detailsLoading,
                    onClick: _ctx.toggleEditMode
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.editMode ? "Vazgeç" : "Düzenle"), 1)
                    ]),
                    _: 1
                  }, 8, ["loading", "disabled", "onClick"]),
                  (_ctx.editMode)
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 0,
                        color: "primary",
                        density: "comfortable",
                        loading: _ctx.saveLoading,
                        disabled: _ctx.detailsLoading,
                        onClick: _ctx.saveAll
                      }, {
                        default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                          _createTextVNode(" Kaydet ", -1)
                        ]))]),
                        _: 1
                      }, 8, ["loading", "disabled", "onClick"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_btn, {
                    icon: "",
                    variant: "text",
                    disabled: _ctx.saveLoading,
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.detailsDialog = false))
                  }, {
                    default: _withCtx(() => [...(_cache[36] || (_cache[36] = [
                      _createElementVNode("i", { class: "material-symbols-outlined" }, "close", -1)
                    ]))]),
                    _: 1
                  }, 8, ["disabled"])
                ])
              ]),
              _createVNode(_component_v_card_text, { style: {"padding":"0"} }, {
                default: _withCtx(() => [
                  (_ctx.detailsError)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(_ctx.detailsError), 1))
                    : _createCommentVNode("", true),
                  (_ctx.detailsLoading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                        _cache[37] || (_cache[37] = _createElementVNode("div", { class: "text-body mb-3" }, "Detaylar yükleniyor…", -1)),
                        _createVNode(_component_v_skeleton_loader, { type: "article, table, article" })
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, [
                          _createVNode(_component_v_tabs, {
                            modelValue: _ctx.detailsTab,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.detailsTab) = $event)),
                            density: "comfortable"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_tab, { value: "quota" }, {
                                default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
                                  _createElementVNode("i", {
                                    class: "material-symbols-outlined me-1",
                                    style: {"font-size":"18px"}
                                  }, "speed", -1),
                                  _createTextVNode(" Kota / Token ", -1)
                                ]))]),
                                _: 1
                              }),
                              _createVNode(_component_v_tab, { value: "qa" }, {
                                default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                                  _createElementVNode("i", {
                                    class: "material-symbols-outlined me-1",
                                    style: {"font-size":"18px"}
                                  }, "chat", -1),
                                  _createTextVNode(" Soru / Cevap ", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          (_ctx.detailsTab === 'qa' && _ctx.selectedUser?.username)
                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                key: 0,
                                variant: "text",
                                size: "small",
                                color: "#1a5f4a",
                                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.openQaPage(_ctx.selectedUser.username)))
                              }, {
                                default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                                  _createElementVNode("span", {
                                    class: "material-symbols-outlined me-1",
                                    style: {"font-size":"16px"}
                                  }, "open_in_new", -1),
                                  _createTextVNode(" Yeni sayfada aç ", -1)
                                ]))]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode(_component_v_window, {
                          modelValue: _ctx.detailsTab,
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.detailsTab) = $event)),
                          class: "mt-3"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_window_item, { value: "quota" }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_32, [
                                  _createElementVNode("div", _hoisted_33, [
                                    _createVNode(_component_v_card, {
                                      class: "trezo-card border-radius d-block bg-white border-0 shadow-none",
                                      style: {"border":"1px solid #eceef2"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_card_text, null, {
                                          default: _withCtx(() => [
                                            _createElementVNode("div", _hoisted_34, [
                                              _cache[41] || (_cache[41] = _createElementVNode("div", { class: "fw-semibold text-black" }, "Soru Kotası", -1)),
                                              _createElementVNode("div", _hoisted_35, " Güncelleme: " + _toDisplayString(_ctx.fmtDate(_ctx.details?.quota?.updated_at)), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_36, [
                                              _createElementVNode("div", _hoisted_37, [
                                                _cache[42] || (_cache[42] = _createElementVNode("span", null, "Kullanılan", -1)),
                                                _createElementVNode("span", null, _toDisplayString(_ctx.details?.quota?.used_count ?? 0) + " / " + _toDisplayString(_ctx.details?.quota?.total_limit ?? 0) + " (Kalan: " + _toDisplayString(_ctx.details?.quota?.remaining ?? _ctx.computedRemaining) + ") ", 1)
                                              ]),
                                              _createVNode(_component_v_progress_linear, {
                                                class: "mt-2",
                                                height: "10",
                                                rounded: "",
                                                "model-value": _ctx.quotaPercent
                                              }, null, 8, ["model-value"])
                                            ]),
                                            _createElementVNode("div", _hoisted_38, [
                                              _createElementVNode("span", _hoisted_39, [
                                                _cache[43] || (_cache[43] = _createTextVNode(" Toplam: ", -1)),
                                                _createElementVNode("b", null, _toDisplayString(_ctx.details?.quota?.total_limit ?? 0), 1)
                                              ]),
                                              _createElementVNode("span", _hoisted_40, [
                                                _cache[44] || (_cache[44] = _createTextVNode(" Kullanılan: ", -1)),
                                                _createElementVNode("b", null, _toDisplayString(_ctx.details?.quota?.used_count ?? 0), 1)
                                              ]),
                                              _createElementVNode("span", _hoisted_41, [
                                                _cache[45] || (_cache[45] = _createTextVNode(" Kalan: ", -1)),
                                                _createElementVNode("b", null, _toDisplayString(_ctx.details?.quota?.remaining ?? _ctx.computedRemaining), 1)
                                              ]),
                                              _createElementVNode("span", _hoisted_42, [
                                                _cache[46] || (_cache[46] = _createTextVNode(" Bugün: ", -1)),
                                                _createElementVNode("b", null, _toDisplayString(_ctx.details?.quota?.asked_today ?? 0), 1),
                                                _cache[47] || (_cache[47] = _createTextVNode(" / ", -1)),
                                                _createElementVNode("b", null, _toDisplayString(_ctx.details?.quota?.effective_daily_limit ?? 0), 1),
                                                (_ctx.details?.quota?.daily_limit != null)
                                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                      _createTextVNode(" (özel)")
                                                    ], 64))
                                                  : _createCommentVNode("", true)
                                              ])
                                            ]),
                                            (_ctx.editMode)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                                  _createElementVNode("div", _hoisted_44, [
                                                    _createElementVNode("div", _hoisted_45, [
                                                      _createVNode(_component_v_text_field, {
                                                        modelValue: _ctx.editForm.quota.total_limit,
                                                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.editForm.quota.total_limit) = $event)),
                                                        modelModifiers: { number: true },
                                                        type: "number",
                                                        min: "0",
                                                        label: "Toplam Limit",
                                                        density: "compact",
                                                        variant: "outlined",
                                                        "hide-details": ""
                                                      }, null, 8, ["modelValue"])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_46, [
                                                      _createVNode(_component_v_text_field, {
                                                        modelValue: _ctx.editForm.quota.used_count,
                                                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.editForm.quota.used_count) = $event)),
                                                        modelModifiers: { number: true },
                                                        type: "number",
                                                        min: "0",
                                                        label: "Kullanılan",
                                                        density: "compact",
                                                        variant: "outlined",
                                                        "hide-details": ""
                                                      }, null, 8, ["modelValue"])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_47, [
                                                      _createVNode(_component_v_text_field, {
                                                        "model-value": _ctx.editRemaining,
                                                        label: "Kalan (otomatik)",
                                                        density: "compact",
                                                        variant: "outlined",
                                                        "hide-details": "",
                                                        readonly: ""
                                                      }, null, 8, ["model-value"])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_48, [
                                                      _createVNode(_component_v_text_field, {
                                                        modelValue: _ctx.editForm.quota.daily_limit,
                                                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.editForm.quota.daily_limit) = $event)),
                                                        modelModifiers: { number: true },
                                                        type: "number",
                                                        min: "0",
                                                        label: "Günlük Limit (boş = varsayılan)",
                                                        density: "compact",
                                                        variant: "outlined",
                                                        "hide-details": "",
                                                        clearable: ""
                                                      }, null, 8, ["modelValue"])
                                                    ])
                                                  ]),
                                                  _createElementVNode("div", _hoisted_49, " Not: remaining backend’de hesaplanıyorsa otomatik gelecektir. Günlük Limit boş bırakılırsa sistem varsayılanı (" + _toDisplayString(_ctx.details?.quota?.default_daily_limit ?? 100) + ") uygulanır. ", 1)
                                                ]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_window_item, { value: "qa" }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_50, [
                                  _cache[48] || (_cache[48] = _createElementVNode("div", { class: "fw-semibold text-black" }, "Soru / Cevap Geçmişi", -1)),
                                  _createElementVNode("div", _hoisted_51, " Kayıt: " + _toDisplayString(_ctx.details?.qa?.length ?? 0), 1)
                                ]),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.details?.qa ?? []), (q) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: q.id,
                                    class: "qa-card"
                                  }, [
                                    _createElementVNode("div", _hoisted_52, [
                                      _createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.fmtDate(q.created_at)), 1),
                                      _createElementVNode("div", _hoisted_54, [
                                        _createElementVNode("span", _hoisted_55, [
                                          _cache[49] || (_cache[49] = _createTextVNode(" doc_type: ", -1)),
                                          _createElementVNode("b", null, _toDisplayString(q.doc_type || "—"), 1)
                                        ]),
                                        ((q.attachments?.length ?? 0) > 0)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_56, [
                                              _cache[50] || (_cache[50] = _createTextVNode(" attachments: ", -1)),
                                              _createElementVNode("b", null, _toDisplayString(q.attachments?.length), 1)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _cache[52] || (_cache[52] = _createElementVNode("div", { class: "fw-semibold text-black mb-1" }, "Soru", -1)),
                                    _createElementVNode("div", _hoisted_57, _toDisplayString(q.question ?? "—"), 1),
                                    _cache[53] || (_cache[53] = _createElementVNode("div", { class: "fw-semibold text-black mb-1" }, "Cevap", -1)),
                                    (q.answer)
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 0,
                                          class: "text-body assistant-answer",
                                          innerHTML: q.answer
                                        }, null, 8, _hoisted_58))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_59, "—")),
                                    ((q.attachments?.length ?? 0) > 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                                          _cache[51] || (_cache[51] = _createElementVNode("div", { class: "fw-semibold text-black mb-1" }, "Attachments", -1)),
                                          _createElementVNode("div", _hoisted_61, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(q.attachments, (a, idx) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: idx,
                                                class: "attachment-pill"
                                              }, _toDisplayString(_ctx.stringifyAttachment(a)), 1))
                                            }), 128))
                                          ])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                }), 128)),
                                ((_ctx.details?.qa?.length ?? 0) === 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_62, " Soru/cevap kaydı bulunamadı. "))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]))
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_63, [
                _createVNode(_component_v_btn, {
                  variant: "outlined",
                  disabled: _ctx.saveLoading,
                  onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.detailsDialog=false))
                }, {
                  default: _withCtx(() => [...(_cache[54] || (_cache[54] = [
                    _createTextVNode("Kapat", -1)
                  ]))]),
                  _: 1
                }, 8, ["disabled"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_dialog, {
        modelValue: _ctx.createDialog,
        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.createDialog) = $event)),
        "max-width": "500",
        persistent: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, { class: "border-radius" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_64, [
                _cache[56] || (_cache[56] = _createElementVNode("div", {
                  class: "fw-semibold text-black",
                  style: {"font-size":"16px"}
                }, "Yeni Kullanıcı Ekle", -1)),
                _createVNode(_component_v_btn, {
                  icon: "",
                  variant: "text",
                  onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.createDialog = false)),
                  disabled: _ctx.createLoading
                }, {
                  default: _withCtx(() => [...(_cache[55] || (_cache[55] = [
                    _createElementVNode("i", { class: "material-symbols-outlined" }, "close", -1)
                  ]))]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _createVNode(_component_v_card_text, { class: "pt-4" }, {
                default: _withCtx(() => [
                  (_ctx.createError)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_65, _toDisplayString(_ctx.createError), 1))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_text_field, {
                    modelValue: _ctx.createForm.name,
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.createForm.name) = $event)),
                    label: "Ad Soyad",
                    variant: "outlined",
                    density: "compact",
                    class: "mb-3",
                    "hide-details": "",
                    disabled: _ctx.createLoading
                  }, null, 8, ["modelValue", "disabled"]),
                  _createVNode(_component_v_text_field, {
                    modelValue: _ctx.createForm.username,
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.createForm.username) = $event)),
                    label: "Kullanıcı Adı",
                    variant: "outlined",
                    density: "compact",
                    class: "mb-3",
                    "hide-details": "",
                    disabled: _ctx.createLoading,
                    hint: "Sadece harf, rakam ve alt çizgi"
                  }, null, 8, ["modelValue", "disabled"]),
                  _createVNode(_component_v_text_field, {
                    modelValue: _ctx.createForm.email,
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.createForm.email) = $event)),
                    label: "E-posta",
                    type: "email",
                    variant: "outlined",
                    density: "compact",
                    class: "mb-3",
                    "hide-details": "",
                    disabled: _ctx.createLoading
                  }, null, 8, ["modelValue", "disabled"]),
                  _createVNode(_component_v_text_field, {
                    modelValue: _ctx.createForm.password,
                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.createForm.password) = $event)),
                    label: "Şifre",
                    type: "password",
                    variant: "outlined",
                    density: "compact",
                    class: "mb-3",
                    "hide-details": "",
                    disabled: _ctx.createLoading
                  }, null, 8, ["modelValue", "disabled"]),
                  _createVNode(_component_v_select, {
                    modelValue: _ctx.createForm.role,
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.createForm.role) = $event)),
                    items: [{ title: 'Kullanıcı', value: 'user' }, { title: 'Admin', value: 'admin' }],
                    label: "Rol",
                    variant: "outlined",
                    density: "compact",
                    "hide-details": "",
                    disabled: _ctx.createLoading
                  }, null, 8, ["modelValue", "disabled"]),
                  _cache[57] || (_cache[57] = _createElementVNode("div", {
                    class: "text-body mt-3",
                    style: {"font-size":"12px"}
                  }, [
                    _createElementVNode("i", {
                      class: "material-symbols-outlined me-1",
                      style: {"font-size":"14px","vertical-align":"middle"}
                    }, "check_circle"),
                    _createTextVNode(" E-posta otomatik olarak doğrulanmış kabul edilecektir. ")
                  ], -1))
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_66, [
                _createVNode(_component_v_btn, {
                  variant: "outlined",
                  disabled: _ctx.createLoading,
                  onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.createDialog = false))
                }, {
                  default: _withCtx(() => [...(_cache[58] || (_cache[58] = [
                    _createTextVNode("İptal", -1)
                  ]))]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_v_btn, {
                  color: "primary",
                  loading: _ctx.createLoading,
                  onClick: _ctx.createUser
                }, {
                  default: _withCtx(() => [...(_cache[59] || (_cache[59] = [
                    _createTextVNode("Kullanıcı Oluştur", -1)
                  ]))]),
                  _: 1
                }, 8, ["loading", "onClick"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}